import { Text, TextProps } from "@chakra-ui/react";
import { useTranslation, TFunction } from "next-i18next";
import { HOUR_IN_MS, DAY_IN_MS, MINUTE_IN_MS } from "src/consts/time";
import { useDateTimeFormatter } from "src/hooks/formatters/use-date-time-formatter";

export function formatCreationDate(t: TFunction, formatDateShort: (creationDate: Date) => string, _creationDate: Date | string): string {
    const creationDate = typeof _creationDate === "string" ? new Date(_creationDate) : _creationDate;

    const differenceInMs = Date.now() - creationDate.getTime();
    const differenceInMinutes = Math.floor(differenceInMs / MINUTE_IN_MS);
    const differenceInHours = Math.floor(differenceInMs / HOUR_IN_MS);

    if (differenceInMinutes < 1) {
        return t("just-now");
    }

    if (differenceInMs < HOUR_IN_MS) {
        return t("x-minutes", { 0: differenceInMinutes });
    }

    if (differenceInMs < DAY_IN_MS) {
        return t("x-hours", { 0: differenceInHours });
    }

    return formatDateShort(creationDate);
}

interface IProps extends TextProps {
    date: Date | string;
}

export const CreationDate = ({ date, ...textProps }: IProps) => {
    const { t } = useTranslation("common");
    const { formatDateShort } = useDateTimeFormatter();

    return (
        <Text fontSize="xs" color="gray.500" {...textProps}>
            {formatCreationDate(t, formatDateShort, date)}
        </Text>
    );
};
